import React, {useEffect, useRef, useState} from "react";
import Panel from "../unfox-design/Panel";
import Header from "../unfox-design/Header";
import Group from "../unfox-design/Group";
import Input from "../unfox-design/Input";
import API from '../../API';
import Button from "../unfox-design/Button";
import Snackbar from "../unfox-design/Snackbar";
import {ReCaptchaKey, TITLE} from "../../config";
import ReCAPTCHA from "react-google-recaptcha";

let Auth = (props) => {
    let [login, setLogin] = useState('');
    let [password, setPassword] = useState('');
    let [snackbar, setSnack] = useState(false);
    let [snackText, setSnackText] = useState('');
    let captchaRef = useRef(null);
    let [captchaKey, SetcaptchaKey] = useState('');

    useEffect(() => {
        props.toggleNav(false);
    })

    function ExecuteLogin() {
        API.execute('auth', {login, password, captcha: captchaKey}).then(data => {
            localStorage.accessToken = data.response.accessToken;
            props.go('profile');
        }).catch(error => {
            const errorMessage = error.error ? error.error['error_message'] : error;
            captchaRef.current.reset();
            showSnack(true, `🤔 ${errorMessage}`);
        });
    }

    let showSnack = (e, text) => {
        setSnackText(text);
        setSnack(e);
    }

    return(
        <Panel>
            <Header status="Auth">
                {TITLE}
            </Header>
            <Group>
                <Input placeholder="Login" onChange={(e) => setLogin(e.target.value.trim())}/>
                <Input placeholder="Password" type="password" onChange={(e) => setPassword(e.target.value.trim())}/>
                <ReCAPTCHA
                    sitekey={ReCaptchaKey}
                    ref={captchaRef}
                    theme={'dark'}
                    onChange={(e) => SetcaptchaKey(e)}
                />
                <div style={{display:"flex", alignItems:"center"}}>
                    <Button size="l" onClick={()=>{
                        ExecuteLogin()
                    }}>Log in</Button>
                    <a style={{margin:"0 18px"}} onClick={()=>{
                        props.go('register')
                    }}>Create Account</a>
                </div>
            </Group>
            <Snackbar start={snackbar} callback={()=>{setSnack(false)}} vertical="bottom" duration={3000}>
                {snackText}
            </Snackbar>
        </Panel>
    )
}

export default Auth;
